import { createI18n } from 'vue-i18n';
import en from '../locales/en.json';
export function setupVueI18n() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const i18n = createI18n({
        locale: 'en',
        globalInjection: true,
        legacy: false,
        runtimeOnly: true,
        messages: {
            en,
        },
    });
    // replace app name here variable name mountAppContext({ microApp }) should match
    if ((_a = window === null || window === void 0 ? void 0 : window.platformBillingApp) === null || _a === void 0 ? void 0 : _a.use)
        window.platformBillingApp.use(i18n);
    if ((_b = window === null || window === void 0 ? void 0 : window.checkoutModal) === null || _b === void 0 ? void 0 : _b.use)
        window.checkoutModal.use(i18n);
    if ((_c = window === null || window === void 0 ? void 0 : window.agencyHipaaApp) === null || _c === void 0 ? void 0 : _c.use)
        window.agencyHipaaApp.use(i18n);
    if ((_d = window === null || window === void 0 ? void 0 : window.supportBilling) === null || _d === void 0 ? void 0 : _d.use)
        window.supportBilling.use(i18n);
    if ((_e = window === null || window === void 0 ? void 0 : window.requestLogs) === null || _e === void 0 ? void 0 : _e.use)
        window.requestLogs.use(i18n);
    if ((_f = window === null || window === void 0 ? void 0 : window.offersPage) === null || _f === void 0 ? void 0 : _f.use)
        window.offersPage.use(i18n);
    if ((_g = window === null || window === void 0 ? void 0 : window.supportHomepage) === null || _g === void 0 ? void 0 : _g.use)
        window.supportHomepage.use(i18n);
    if ((_h = window === null || window === void 0 ? void 0 : window.sandboxLockoutPage) === null || _h === void 0 ? void 0 : _h.use)
        window.sandboxLockoutPage.use(i18n);
    if ((_j = window === null || window === void 0 ? void 0 : window.upgradeModal) === null || _j === void 0 ? void 0 : _j.use)
        window.upgradeModal.use(i18n);
    if ((_k = window === null || window === void 0 ? void 0 : window.agencyBillingName) === null || _k === void 0 ? void 0 : _k.use)
        window.agencyBillingName.use(i18n);
}
